/**
 * Runs `onReady` once `window.i18next.t()` will answer with real text rather than an empty string. For a widget that mounts into a container the server already filled — a
 * skeleton, say.
 */
export const whenTranslationsReady = (onReady: VoidFunction): void => {
  window.PMW.initI18next(window.PMW.LANGUAGE, onReady);
};
